import React from 'react';
import PropTypes from 'prop-types';
import { Popover, ButtonGroup, Button, OverlayTrigger } from 'react-bootstrap';
import exportIcon from '../../assets/images/icons/export-icon.png';

const PageExport = ({ title, pdf }) => {
  const popoverClickRootClose = () => (
    <Popover
      id="popover-trigger-click-root-close"
      title={title}
      className="tvt-page-export__popover"
    >
      <ButtonGroup className="tvt-page-export__btn-group">
        {pdf && (
          <Button
            onClick={() => window.print()}
            className="tvt-page-export__btn"
          >
            <img
              src={exportIcon}
              alt="Export"
              className="tvt-page-export__btn-icon"
            />
            <span className="tvt-page-export__btn-label">.pdf</span>
          </Button>
        )}
      </ButtonGroup>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="bottom"
      overlay={popoverClickRootClose()}
    >
      <Button className="tvt-page-export">
        <img src={exportIcon} alt="Export" />
      </Button>
    </OverlayTrigger>
  );
};

PageExport.propTypes = {
  title: PropTypes.string,
  pdf: PropTypes.bool
};

PageExport.defaultProps = {
  title: '',
  pdf: false
};

export default PageExport;
